import { useAtom } from 'jotai';
import { useState } from 'react';

import { activeOrganizationsAtom } from '@/pages/Organizations';
import { userIsInternalAtom } from '@/store/user.store';

import {
  selectedAnnouncementAtom,
  useAddAnnouncementAttachment,
  useCreateAnnouncement,
  useDeleteAnnouncement,
  useDeleteAnnouncementAttachment,
  usePublishAnnouncement,
  useUpdateAnnouncement
} from './Announcements.store';

const useAnnouncements = () => {
  const [organizations] = useAtom(activeOrganizationsAtom);

  const [selectedAnnouncement, setSelectedAnnouncement] = useAtom(
    selectedAnnouncementAtom
  );
  const [userIsInternal] = useAtom(userIsInternalAtom);
  const {
    mutate: createAnnouncement,
    isSuccess,
    data
  } = useCreateAnnouncement();
  const { mutate: updateAnnouncement, isPending: updateAnnouncementLoading } =
    useUpdateAnnouncement(selectedAnnouncement?.id);
  const deleteAnnouncement = useDeleteAnnouncement();
  const publishAnnouncement = usePublishAnnouncement();
  const deleteAttachment = useDeleteAnnouncementAttachment();
  const {
    mutate: addAttachment,
    isError: addAttachmentError,
    isPending: addAttachmentLoading,
    isSuccess: addAttachmentSuccess
  } = useAddAnnouncementAttachment();

  const [selectedGroupList, setSelectedGroupList] = useState<string[]>([]);

  return {
    addAttachment,
    addAttachmentError,
    addAttachmentLoading,
    addAttachmentSuccess,
    createAnnouncement,
    data,
    deleteAnnouncement,
    deleteAttachment,
    isSuccess,
    organizations,
    publishAnnouncement,
    selectedAnnouncement,
    selectedGroupList,
    setSelectedAnnouncement,
    setSelectedGroupList,
    updateAnnouncement,
    updateAnnouncementLoading,
    userIsInternal
  };
};

export default useAnnouncements;
